// src/utils/dateUtils.js
import React from 'react';
import { useMemo } from 'react';
import { parse, format } from 'date-fns';
import XIconComp from './XIconComp';

/**
 * Parses a date string into a valid formatted date.
 * @param {string} date - The date string to be parsed, default '28/02/2024'.
 * @param {string} formatString - The input format of the date string.
 * @param {string} formatValue - The output format of the date string.
 * @returns {string|null} - Returns the formatted date string or the original value if invalid.
 */

// Parse the date string and format it correctly
export const parseDate = (date , formatString='dd/MM/yyyy', formatValue='dd/MM/yyyy') => {
  // console.log(date, formatString, formatValue, "ssaa");  // Log inputs for debugging

  let parsedDate;
  if (date && date !== "" && date != null && date != undefined) {
    // Parse the date using the correct format
    if (typeof date === 'string') {
      parsedDate = parse(date, formatString, new Date());
    } else if (date instanceof Date) {
      parsedDate = date;
    } else {
      return '';
    }
    // const parsedDate = typeof date === 'string' ? parse(date, formatString, new Date()) : date;

    // console.log(parsedDate, "parsedDate");  // Log parsed date for debugging

    // Check if it's a valid date
    if (!isNaN(parsedDate)) {
      // Format the date using the output formatValue
      const formattedDate = format(parsedDate, formatValue);
      // console.log(formattedDate, "formattedDate");  // Log formatted date for debugging
      return formattedDate;
    } else {
      return date; // Return the original date if invalid
    }
  }
  return null;
};

const normalizeDate = (dateStr) => {
  if (!dateStr) return null;

  const date = new Date(dateStr);

  if (isNaN(date.getTime())) return null;

  const year = date.getFullYear() || '';
  const month = String(date.getMonth() + 1).padStart(2, '0') || '';
  const day = String(date.getDate()).padStart(2, '0') || '';

  return { year, month, day };
};


export const useParsedStartDate = (resetFlag, filteredStartDate, startDate, formatValue) => {
  console.log(resetFlag, filteredStartDate, startDate, formatValue,"[Pavan] resetFlag");
  
  return useMemo(() => {
    if (resetFlag) {
      if (!filteredStartDate) return null; 
      let  {year, month, day} = normalizeDate(filteredStartDate)
      console.log( year, month, day," year, month, day resetFlag 1");

      let new_date = `${day}/${month}/${year}`
      
      return parseDate(new_date, 'dd/MM/yyyy', formatValue);  // Assuming input is in 'dd/MM/yyyy' format
    }
    if (!startDate) return null; 
    return parseDate(startDate, 'yyyy-MM-dd', formatValue); 
    // return parseDate(startDate, 'dd/MM/yyyy', formatValue);
  }, [resetFlag, filteredStartDate, startDate, formatValue]);
};

export const useParsedEndDate = (resetFlag, filteredEndDate, endDate, formatValue) => {
  return useMemo(() => {    
    if (resetFlag) {
    if (!filteredEndDate) return null; 
      let  {year, month, day} = normalizeDate(filteredEndDate)
      console.log( year, month, day," year, month, day resetFlag 1");

      let new_date = `${day}/${month}/${year}`
      
      return parseDate(new_date, 'dd/MM/yyyy', formatValue);  // Assuming input is in 'dd/MM/yyyy' format
    }
    if (!endDate) return null; 
    return parseDate(endDate, 'yyyy-MM-dd', formatValue); 
    // return parseDate(endDate, 'dd/MM/yyyy', formatValue);
  }, [resetFlag, filteredEndDate, endDate, formatValue]);
};


export const seperateValFunc = (val) => {
  if(val){
      const parts = val.split(" ");
      return parts.map((word, index) => (
          word === 'Twitter' ? 
              <XIconComp key={index} style={{ marginRight: 4 }} /> : 
              <span key={index} style={{ marginRight: 4 }}>{word}</span>
      ));
  }
  return ' ';
}